import React, { useState } from 'react'
import { Box, Typography, Container, CircularProgress } from '@mui/material'
import ZohranEndorsment from '../../components/ZohranEndorsement'
import ZipSearch from './ZipSearch'
import CandidateResult from '../../components/CandidateResult'

export default function HomePageV2() {
    const [candidatesLoading, setCandidatesLoading] = useState(false)
    const [candidatesList, setCandidateList] = useState()
    const [error, setError] = useState()
    const handleZipSubmit = async (zip) => {
        console.log(zip)
        setCandidatesLoading(true)
        try {
            // for the 2025 election, the only focus is on NY City elections, so to keep flexibility, a hardcoded address is used. The only thing actually important for this search is the ZipCode, but a hard coded address is supplied to prevent needing to rewrite large amounts of back end functionality
            const hardCodedAddress = {
                street: '9202 3rd Ave',
                city: 'Brooklyn',
                state: 'NY',
                fullState: 'New York',
                postalcode: zip,
            }
            const res = await fetch('/api/newCandidate/getDistrict', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(hardCodedAddress),
            })
            const data = await res.json()
            if (data.success) {
                setCandidateList(data.data)
            }
        } catch (er) {
            setError(`There was an error getting data: ${er.message}`)
        }
        setCandidatesLoading(false)
    }
    return (
        <>
            <Typography variant="h1">
                2025 NYC Council Election Primaries
            </Typography>
            <Box sx={{ mb: 2 }}>
                <ZohranEndorsment />
            </Box>
            <Container
                sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    border: '2px solid #9e522a',
                    borderRadius: '10px',
                }}
            >
                <Box>
                    <ZipSearch handleSubmit={handleZipSubmit} />
                    {candidatesLoading && <CircularProgress />}
                    {error && (
                        <Typography variant="p" color="red">
                            {error}
                        </Typography>
                    )}

                    {candidatesList && !candidatesLoading && (
                        <div>
                            {candidatesList.flat().length === 0 ? (
                                <Container
                                    sx={{
                                        display: 'flex',
                                        flexFlow: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Typography variant="p" fontWeight="bold">
                                        Sorry, we don&apos;t have info for your
                                        ballot ready yet!
                                    </Typography>
                                    <Typography variant="p">
                                        Checkout <a href="/">Ballotpedia</a> in
                                        the interim.
                                    </Typography>
                                    <Typography variant="p">
                                        Check <a href="/">Instagram</a> or{' '}
                                        <a href="/">TikTok</a> for updates.
                                    </Typography>
                                </Container>
                            ) : (
                                <CandidateResult candidates={candidatesList} />
                            )}
                        </div>
                    )}
                </Box>
            </Container>
        </>
    )
}
